// extracted by mini-css-extract-plugin
module.exports = {"root":"sibling-products-module__root___EkKXi","title":"sibling-products-module__title___3T221","content":"sibling-products-module__content___E66SN"};